module.exports = __webpack_public_path__ + "img/banner-line_big_dark.d7380ef4.png";